import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/outline';

type SortOrder = 'asc' | 'desc' | 'ASC' | 'DESC';

interface SortOrderButtonProps {
  order: SortOrder;
  onToggle: () => void;
  className?: string;
}

function isAscending(order: SortOrder): boolean {
  return order === 'asc' || order === 'ASC';
}

export default function SortOrderButton({ order, onToggle, className = '' }: SortOrderButtonProps) {
  const asc = isAscending(order);
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex items-center rounded-md p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-700 ${className}`.trim()}
      aria-label={asc ? 'Sorted ascending — click for descending' : 'Sorted descending — click for ascending'}
      title={asc ? 'Ascending' : 'Descending'}
    >
      {asc ? <ArrowUpIcon className="h-5 w-5" aria-hidden /> : <ArrowDownIcon className="h-5 w-5" aria-hidden />}
    </button>
  );
}
